import * as React from 'react';

import './PageBlock.scss';

interface IPageBlockProps {
  children?: JSX.Element[] | JSX.Element | string;
  className?: string;
}

const PageBlock: React.SFC<IPageBlockProps> = ({ children, className }) => {
  return (
    <div className={`page-block${className ? ' ' + className : ''}`}>
      {children}
    </div>
  );
};

export default PageBlock;
